import {Pagination} from 'antd'
import React, {useEffect, useState} from 'react'
import NewsCard from './newsCard'
import API from '../../api'
import {News} from '../../api/news'
import SearchBar from 'components/SearchBar'
const NewsCom = () => {
  const [newsList, setNewsList] = useState<News[]>([])
  const [total, setTotal] = useState(0)

  const [current, setCurrent] = useState(1)

  const handlePageChange = page => {
    setCurrent(page)
  }

  useEffect(() => {
    const updateNewsList = () => {
      API.getNewsList({offset: (current - 1) * 10, limit: 10}).then(res => {
        let news = res.data.news || []
        setNewsList(news)
        setTotal(res.data.total)
      })
    }
    updateNewsList()
  }, [current])

  return (
    <>
      <div style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/news-banner.png)`}}>
        <SearchBar module="News Center" />
      </div>
      <div className="layout-content-mask">
        <div className="layout-content-bg-LB"></div>
        <div className="layout-content-bg-RT"></div>
        <div className="news-container">
          <div style={{color: '#262626'}} className="news-total">
            共计{total}条消息
          </div>
          {/* 引入新闻卡片 */}
          {newsList.map((news, index) => (
            <NewsCard news={news} key={news.id} />
          ))}

          <div className="news-pager">
            {/* 分页 */}
            <Pagination
              total={total}
              showTotal={total => `共 ${total} 条内容`}
              defaultPageSize={10}
              showSizeChanger={false}
              onChange={handlePageChange}
              current={current}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default NewsCom
